// extracted by mini-css-extract-plugin
module.exports = {"bg-image":"styles_bg-image__ZufmK","bg-contact":"styles_bg-contact__T_2LB","review-3":"styles_review-3__6stp2","header-mp4":"styles_header-mp4__VXIx5"};